import { httpGet, httpPost } from '@pressreader/services';

import { IBookDetailsDto, IBooksContinuationResultDto, IBooksSearchResultDto, IContributorDto, IGenreDto, ISeriesDto } from './book.dto';
import { IBookQuery, IContinuationBookQuery } from './models';

// https://ingress.pressreader.com/services/book-catalog/swagger/index.html
// https://ingress-dev.pressreader.com/book-catalog/swagger/index.html
const service = 'book-catalog/v1';

async function getBooksCatalogSearch(filter: IBookQuery): Promise<IBooksSearchResultDto> {
    return httpPost(service, 'books/search', JSON.stringify(filter || {}), {
        contentType: 'application/json',
        disableRetry: true,
    });
}

async function isBookCatalogAvailable(): Promise<boolean> {
    const booksDto = await getBooksCatalogSearch({});
    const total = booksDto?.meta?.total;
    return typeof total === 'number' && total > 0;
}

async function getContinuationBooksCatalogSearch(continuation: IContinuationBookQuery): Promise<IBooksContinuationResultDto> {
    return httpPost(service, 'books/search/continue', JSON.stringify(continuation), {
        contentType: 'application/json',
        disableRetry: true,
    });
}

async function getBooksCatalogCategoryInfo(id: number): Promise<IGenreDto> {
    return httpGet(service, `categories/${id}`);
}

async function getBooksCatalogCategoryInfoBySlug(slug: string): Promise<IBookDetailsDto> {
    return httpGet(service, 'categories/by-slug', { slug });
}

async function getBooksCatalogCategoriesInfo(ids: number[]): Promise<IGenreDto[]> {
    return httpPost(service, 'categories/resolve', JSON.stringify({ ids }), {
        contentType: 'application/json',
        disableRetry: true,
    });
}

async function resolveBooksCatalogCategoriesPath(path: string): Promise<IGenreDto> {
    return httpGet<IGenreDto>(service, `categories/resolve/${path}`);
}

async function getBookInfo(bookId: number): Promise<IBookDetailsDto> {
    return httpGet(service, `books/${bookId}`, {});
}

async function getBookInfoBySlug(slug: string): Promise<IBookDetailsDto> {
    return httpGet(service, 'books/by-slug', { slug });
}

async function getBooksInfo(ids: number[]): Promise<IBookDetailsDto[]> {
    return httpPost(service, 'books', JSON.stringify({ ids }), {
        contentType: 'application/json',
        disableRetry: true,
    });
}

async function getContributorInfo(contributorId: number): Promise<IContributorDto> {
    return httpGet(service, `contributors/${contributorId}`, {});
}

async function getContributorInfoBySlug(slug: string): Promise<IContributorDto> {
    return httpGet(service, 'contributors/by-slug', { slug });
}

async function getSeriesInfo(seriesId: number): Promise<ISeriesDto> {
    return httpGet(service, `series/${seriesId}`, {});
}

async function getSeriesInfoBySlug(slug: string): Promise<ISeriesDto> {
    return httpGet(service, 'series/by-slug', { slug });
}

export {
    getBookInfo,
    getBookInfoBySlug,
    getBooksCatalogCategoriesInfo,
    getBooksCatalogCategoryInfo,
    getBooksCatalogCategoryInfoBySlug,
    getBooksCatalogSearch,
    getBooksInfo,
    getContinuationBooksCatalogSearch,
    getContributorInfo,
    getContributorInfoBySlug,
    getSeriesInfo,
    getSeriesInfoBySlug,
    isBookCatalogAvailable,
    resolveBooksCatalogCategoriesPath,
};
